export const paymentTableStyle = {
    '.MuiDataGrid-columnHeaderTitleContainer': {
        justifyContent: 'left'
    },
    '.MuiDataGrid-cell': {
        justifyContent: 'left',
    },
};